import { switchMap } from "rxjs";
import { ofType } from "redux-observable";
import { actions, actionTypes } from "./actions";
import * as Api from "./api";

export const servicesRequest = (action$) =>
  action$.pipe(
    ofType(actionTypes.SERVICES_REQUEST),
    switchMap((action) =>
      Api.getServices(action.payload)
        .then((response) => {
          return actions.servicesRequestSuccess(response);
        })
        .catch((error) => actions.servicesRequestFailed(error))
    )
  );

export default [servicesRequest];
